// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#name p[data-v-64aa1d23]{line-height:1.2}#remove[data-v-64aa1d23]{padding-right:15px}#price[data-v-64aa1d23]{margin-left:auto;padding-left:10px}select[data-v-64aa1d23]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#2b5449 url(https://a.storyblok.com/f/99717/x/de0ebe3f36/icon-dropdown-white.svg) no-repeat right 8px center}", ""]);
// Exports
module.exports = exports;
